<template>
  <v-dialog v-model="dialogState" :content-class="'image-detail-modal__container elevation-0'" scrim="black50" persistent>
    <div class="dialog-header wd-flex wd-justify-center">
      <div class="dialog-title wd-relative">
        <p v-if="!shouldHidePaginationNumber" class="text-h5 wd-text-white">{{ `${paginationNum}/${images.length}` }}</p>
        <v-btn class="close-btn" :min-width="28" :width="24" :height="32" variant="text" @click="closeIconEvent">
          <v-icon icon="mdi-close" color="white"></v-icon>
        </v-btn>
      </div>
    </div>

    <div class="image-swiper__container mt-2">
      <v-btn
        class="swiper-btn swiper-btn--prev pa-0"
        :class="{ hidden: hiddenSwiperBeginning }"
        min-width="32"
        height="32"
        variant="text"
        @click="prevSwiper"
      >
        <funnow-icon max-width="24" :image-path="'chevron-left_white.svg'" />
      </v-btn>

      <swiper
        ref="imageDetailSwiper"
        class="image-detail-swiper"
        v-bind="swiperOptionTop"
        @slide-change-transition-end="onSlideTopChangeEnd"
        @swiper="onSwiper"
      >
        <swiper-slide v-for="(imagePathOrUrl, index) in images" :key="imagePathOrUrl + index" class="d-sm-flex">
          <v-img class="detail-picture mx-auto" :src="getImageUrl(imagePathOrUrl)" :max-width="640" aspect-ratio="1" cover />
        </swiper-slide>
      </swiper>

      <v-btn
        class="swiper-btn swiper-btn--next pa-0"
        :class="{ hidden: hiddenSwiperEnd }"
        min-width="32"
        height="32"
        variant="text"
        @click="nextSwiper"
      >
        <funnow-icon max-width="24" :image-path="'chevron-right_white.svg'" />
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import utils from '@/utils'

import FunnowIcon from '@/components/icons/funnow-icon.vue'

export default {
  name: 'ImageDetailModal',
  components: {
    Swiper,
    SwiperSlide,
    FunnowIcon,
  },
  props: {
    images: { type: Array, default: () => [] },
    slideNumber: { type: Number, default: 1 },
    shouldHidePaginationNumber: { type: Boolean, default: false },
    shouldEncodeImagePath: { type: Boolean, default: true },
  },
  data() {
    return {
      dialogState: false,
      hiddenSwiperBeginning: true,
      hiddenSwiperEnd: false,
      paginationNum: this.slideNumber || 1,
      swiperOptionTop: {
        init: false,
      },
      swiper: null,
    }
  },
  computed: {},
  watch: {
    slideNumber(newNumber) {
      this.paginationNum = newNumber
    },
  },
  mounted() {},
  methods: {
    // args would be one of: 1. external URL 2. CDN link with domain 3. CDN link without domain
    getImageUrl(imagePathOrUrl) {
      // image URL(1. and 2.)
      if (!this.shouldEncodeImagePath) {
        return imagePathOrUrl
      }

      // image path(3.)
      return `${utils.CDN}${utils.imagePath(imagePathOrUrl)}`
    },
    updateSwiperButton(swiper) {
      this.$nextTick(() => {
        if (!swiper) {
          return
        }
        this.hiddenSwiperBeginning = this.swiper.isBeginning
        this.hiddenSwiperEnd = this.swiper.isEnd
      })
    },
    toSlide(pageNum) {
      this.swiper.slideTo(pageNum, 100, false)
    },
    prevSwiper() {
      this.swiper.slidePrev()
    },
    nextSwiper() {
      this.swiper.slideNext()
    },
    onSlideTopChangeEnd(swiper) {
      this.updateSwiperButton(swiper)
      this.paginationNum = swiper.activeIndex + 1
    },
    showModal(selector) {
      this.dialogState = true
      setTimeout(() => {
        // this.$refs.imageDetailSwiper.$swiper.init()

        const swiperIndex = this.paginationNum - 1
        this.toSlide(swiperIndex)
        this.updateSwiperButton(this.swiper)
      }, 100)
    },
    closeIconEvent() {
      this.dialogState = false
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
  },
}
</script>

<style scoped lang="scss">
.image-detail-modal__container {
  .dialog-header {
    margin-top: 64px;
    margin-bottom: 44px;
    position: relative;
    .dialog-title {
      width: 640px;
      text-align: center;
      .headline {
        font-size: 17px !important;
        color: white;
      }
    }

    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .image-swiper__container {
    position: relative;
    padding: 0 76px;

    @include xxs {
      padding: 0;
    }

    .swiper-btn {
      @include xxs {
        display: none;
      }

      &.hidden {
        visibility: hidden;
      }

      &--prev {
        position: absolute;
        top: calc(50% - 20px);
        left: 0;
      }

      &--next {
        position: absolute;
        top: calc(50% - 20px);
        right: 0;
      }
    }

    .image-detail-swiper {
      height: calc(100vh - 180px);
      .detail-picture {
        width: 76%;

        @include xxs {
          width: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.image-detail-modal__container {
  max-width: 792px;
  height: 100vh;
  max-height: 100vh !important;
  overflow-x: hidden;

  @include xxs {
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
